import { createSelector } from 'redux-bundler';
import errorsExist from 'utils/errorsExist';

import { READ_ORGANIZATION } from '../constants';

export const reactReadOrganizations = createSelector(
  'selectIsLoggedIn',
  'selectAllOrganizationIDs',
  'selectFreshOrganizationsKey',
  'selectIsFetchingOrganization',
  'selectErrors',
  (isLoggedIn, allIDs, freshOrganizations, isFetchingOrganization, errors) => {
    const organizationErrors = errorsExist([READ_ORGANIZATION], errors);
    const organizationIDsToFetch = [];

    if (allIDs.length) {
      for (let i = 0, l = allIDs.length; i < l; i += 1) {
        if (!freshOrganizations[allIDs[i]]?.details)
          organizationIDsToFetch.push(allIDs[i]);
      }
    }

    if (
      !isLoggedIn ||
      isFetchingOrganization ||
      organizationErrors ||
      !organizationIDsToFetch.length
    ) {
      return false;
    }

    return {
      actionCreator: 'doReadOrganization',
      args: [{ organizationIDs: organizationIDsToFetch }],
    };
  },
);
